// extracted by mini-css-extract-plugin
export var phone = "_27-0";
export var phoneDragging = "_27-1";